import UserInfo from './UserInfo';
import './UserInfo.scss';

export default UserInfo;
